import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ListChannelsModeratedByAppInstanceUserRequestFilterSensitiveLog, ListChannelsModeratedByAppInstanceUserResponseFilterSensitiveLog, } from "../models/models_0";
import { de_ListChannelsModeratedByAppInstanceUserCommand, se_ListChannelsModeratedByAppInstanceUserCommand, } from "../protocols/Aws_restJson1";
export { $Command };
export class ListChannelsModeratedByAppInstanceUserCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "ListChannelsModeratedByAppInstanceUser", {})
    .n("ChimeSDKMessagingClient", "ListChannelsModeratedByAppInstanceUserCommand")
    .f(ListChannelsModeratedByAppInstanceUserRequestFilterSensitiveLog, ListChannelsModeratedByAppInstanceUserResponseFilterSensitiveLog)
    .ser(se_ListChannelsModeratedByAppInstanceUserCommand)
    .de(de_ListChannelsModeratedByAppInstanceUserCommand)
    .build() {
}
